<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">{{title}}</h4>
</div>
<div class="modal-body">
    <disbursement-summary [financeDisbursementRequestId]="data.financeDisbursementRequestId"></disbursement-summary>
</div>